import * as R from 'ramda'
import React, { createContext, useState } from 'react'
import { navigate, graphql, useStaticQuery } from 'gatsby'
import sys from '../util/globalFunction'
import menuMap, { defaultMenu } from '../layout/menus'
import config from '../config'
import tremSession from '../util/tremSession'
import tremApi from '../util/tremApi'

const __defaultLoginInfo__ = {
    loggined: false,
    USER_SKEY: null,
    LOGIN_ID: null,
    NAME: null,
    ENG_NAME: null,
    COMPANY_SKEY: null,
    COMPANY_NAME: null,
    DEPT_SKEY: null,
    DEPT_NAME: null,
    JOIN_TYPE: 'N',
    auths: {
        menuMap:
            process.env.NODE_ENV === 'production' || config.applyAuthMenu ? defaultMenu : menuMap,
    },
    avatarImage: null,
}
//세션 스토리지로 사용자 정보 관리
const getLoginInfo = R.pipe(
    () => typeof window !== 'undefined' && window.sessionStorage.getItem('__login_info__'),
    R.ifElse(R.identity, sys.decryptToObj, () => __defaultLoginInfo__)
)

const removeLoginInfo = () => {
    _session_start_dt = null
    window.sessionStorage.removeItem('__login_info__')
}

export const setLoginInfo = R.pipe(sys.encryptObj, txt => {
    _session_start_dt = Date.now()
    window.sessionStorage.setItem('__login_info__', txt)
})

// 화면 layout 모드
let ___layout_mode___ = 'operation'

/**
 * Pulic 모드 인지 확인, gloablFunction에서 사용
 * 설정은 반드시 globalContext를 이용해서 해야함.
 * @returns boolean
 */
export const getLayoutMode = () => ___layout_mode___
export const setLayoutMode = mode => (___layout_mode___ = mode)

const __doc__list__ = {}

const makeDocList = data => {
    const {
        allFile: { edges: files },
        allMarkdownRemark: { edges: mds },
    } = data

    files.forEach(({ node: { name, absolutePath, relativeDirectory } }) =>
        R.pipe(
            R.ifElse(
                () => name === 'index',
                () => `/${relativeDirectory}/`,
                () => `/${relativeDirectory}/${name}/`
            ),
            url => {
                const finded = mds.find(
                    ({ node: { fileAbsolutePath } }) => fileAbsolutePath === absolutePath
                )
                const {
                    node: {
                        html,
                        frontmatter: { title },
                    },
                } = finded
                __doc__list__[url] = { title, __html: html.replace(/\r\n/gi, '<br />') }
            }
        )()
    )
}

//timeout 설정
let _session_start_dt = null
let _logout_funtion = null

const setTimerFormat = (seconds) => {
    let nHour = 0
    let nMin = 0
    let nSec = 0
    if(seconds > 0) {
        nMin = parseInt(seconds / 60)
        nSec = seconds % 60
        if(nMin > 60) {
            nHour = parseInt(nMin / 60)
            nMin = nMin % 60
        }
    }
    if(nSec < 10) {
        nSec = "0" + nSec
    }
    if(nMin < 10) {
        nMin = "0"+nMin
    }

    return "" + nHour + ":" + nMin + ":" + nSec
}

//로그인 타이머
const checkSessionExpiredTime = () => {
    const userInfo = getLoginInfo() || { loggined: false }
    
    //로딩 중 새로고침시 로그아웃 되는 이슈 
    //값들이 초기화 되지 않은 상태에서 diff값에 Date.now 값이 대입되 로그아웃 if문을 실행, _session_start_dt이 null아닐경우에 실행되도록
    if (userInfo.loggined && _session_start_dt) {
        if (_logout_funtion ) {
            const diff = Date.now() - _session_start_dt
            const math = Math.floor(config.loginMaintainenceTime-(diff/1000))
            const timers = document.getElementsByClassName("timeCounter")

            if(timers && timers.length!==0){
                timers[0].innerHTML = setTimerFormat(math) //텍스트 세팅
                timers[1].innerHTML = setTimerFormat(math)
            }
            //~초 뒤 로그아웃 알람 - excuteAlarmTime는 config파일에서 세팅, 단위(초)
            if(math == config.excuteAlarmTime){
                sys.alert(`${math}초 뒤 자동 로그아웃됩니다.`, '알림')
            }

            //config 파일에 loginMaintainenceTime 값. 단위(초), 타이머 끝나면 로그아웃
            if (diff > config.loginMaintainenceTime * 1000) {
                _logout_funtion()
            }
        } else {
            console.log('로그아웃 함수가 세팅되지 않았습니다.')
        }
    }
}

//타이머 초기화
export const setSessionStartDt = () => {
    _session_start_dt = Date.now()
}

setInterval(checkSessionExpiredTime, 1000)

//컨텍스트 설정
export const GlobalContext = createContext()

let __flg_refresh__ = false //useCallback등 귀찮은 것 피하려고 씀

const GlobalProvider = props => {
    const { children } = props
    const [flagRefresh, setRefresh] = useState(__flg_refresh__)

    //도움말 정의
    const data = useStaticQuery(graphql`
        query {
            allMarkdownRemark {
                edges {
                    node {
                        fileAbsolutePath
                        html
                        frontmatter {
                            title
                        }
                    }
                }
            }
            allFile(filter: { ext: { eq: ".md" } }) {
                edges {
                    node {
                        name
                        absolutePath
                        relativeDirectory
                    }
                }
            }
        }
    `)
    makeDocList(data)

    /**
     * 로그인 페이지로 이동
     */
    const gotoLoginPage = () => {
        const previousPage = window.location.pathname
        navigate('/login', {
            state: { previousPage },
        })
    }

    /**
     * 페이지로 이동
     * @param {*} url 이동할 url
     * @param {*} params 파라미터
     */
    const gotoPage = (url, params) => {
        const state = { ...params, prevPath: url }
        __is_public_layout_mode__ || window.location.pathname === url
            ? navigate('/redirectPrev', { state })
            : navigate(url, { state })
    }

    /**
     * 사용자 로그인
     * @param {string} USER_SKEY 사용자키
     * @param {string} LOGIN_ID 사용자ID
     * @param {string} NAME 사용자명
     * @param {string} ENG_NAME 사용자명(영문)
     * @param {string} COMPANY_SKEY 소속키
     * @param {string} COMPANY_NAME 소속명
     * @param {string} DEPT_SKEY 부서키
     * @param {string} DEPT_NAME 부서명
     * @param {string} JOIN_TYPE 사용자권한 유형
     * @param {*} auths 사용자 권한
     * @param {*} previousPage 로그인 화면 이전 페이지
     * @param {*} avatarImage 아바타 rul
     */
    const login = (
        USER_SKEY,
        LOGIN_ID,
        NAME,
        ENG_NAME,
        COMPANY_SKEY,
        COMPANY_NAME,
        DEPT_SKEY,
        DEPT_NAME,
        JOIN_TYPE,
        auths,
        COMPANY_DIV,
        previousPage,
        avatarImage = null
    ) => {
        const loggined = true
        setLoginInfo({
            loggined,
            USER_SKEY,
            LOGIN_ID,
            NAME,
            ENG_NAME,
            COMPANY_SKEY,
            COMPANY_NAME,
            DEPT_SKEY,
            DEPT_NAME,
            JOIN_TYPE,
            auths: config.applyAuthMenu ? auths : { menuMap },
            COMPANY_DIV,
            avatarImage,
        })

        previousPage = (previousPage || '').replace(config.serverPrefixUrl + '/m/', '/')
        navigate(previousPage !== '/login' ? previousPage : '/')
        refresh()
    }

    // SSO(sbh에서 접속 후 tree 접근시 세션값을 가져옴) // sso로 접근하여 이미 세션이 만들어져 있음 그것을 
    const setSSOinfo= async() => await tremApi('/session/info/load/make/session').then(obj => {
        if(obj?.sucess==="S"){
            const{
                USER_SKEY,
                LOGIN_ID,
                NAME,
                ENG_NAME,
                COMPANY_SKEY,
                COMPANY_NAME,
                DEPT_SKEY,
                DEPT_NAME,
                JOIN_TYPE,
                auths,
                COMPANY_DIV,
                avatarImage
            } = obj.UserInfo

            const loggined = true
            setLoginInfo({
                loggined,
                USER_SKEY,
                LOGIN_ID,
                NAME,
                ENG_NAME,
                COMPANY_SKEY,
                COMPANY_NAME,
                DEPT_SKEY,
                DEPT_NAME,
                JOIN_TYPE,
                auths: config.applyAuthMenu ? auths : { menuMap },
                COMPANY_DIV,
                avatarImage,
            })
            refresh()
        }
    })

    /**
     * 사용자 정보를 갱신 hello를 호출할 때 마다 login 페이지가 아닌 자료만 호출
     * @param {string} USER_SKEY 사용자키
     * @param {string} LOGIN_ID 사용자ID
     * @param {string} NAME 사용자명
     * @param {string} ENG_NAME 사용자명(영문)
     * @param {string} COMPANY_SKEY 소속키
     * @param {string} COMPANY_NAME 소속명
     * @param {string} DEPT_SKEY 부서키
     * @param {string} DEPT_NAME 부서명
     * @param {string} JOIN_TYPE 사용자권한 유형
     * @param {*} auths 사용자 권한
     * @param {*} previousPage 로그인 화면 이전 페이지
     * @param {*} avatarImage 아바타 rul
     */
    const setuserInfo = (
        USER_SKEY,
        LOGIN_ID,
        NAME,
        ENG_NAME,
        COMPANY_SKEY,
        COMPANY_NAME,
        DEPT_SKEY,
        DEPT_NAME,
        JOIN_TYPE,
        auths,
        COMPANY_DIV,
        avatarImage = null
    ) => {
        const loggined = true
        setLoginInfo({
            USER_SKEY,
            LOGIN_ID,
            NAME,
            ENG_NAME,
            COMPANY_SKEY,
            COMPANY_NAME,
            DEPT_SKEY,
            DEPT_NAME,
            JOIN_TYPE,
            auths,
            COMPANY_DIV,
            avatarImage,
        })
        refresh()
    }

    /**
     * 로그아웃
     */
    const logout = () => {
        ///로그아웃 처리
        tremSession.setRmSessionInfo().then(data => {
            window.localStorage.removeItem('__access_token__')
            //setLoginInfo(__defaultLoginInfo__)
            removeLoginInfo()
            sys.alert('로그아웃 되었습니다.', '알림')
            sys.gotoHomePage()
            refresh()
        })
    }

    _logout_funtion = logout

    /**
     * pulic layout 설정, false일때는 운영화면
     * @param {boolean} isPbulic
     * @returns
     */
    const setPublicLayout = isPbulic =>
        R.when(
            () => __is_public_layout_mode__ !== isPbulic,
            () => {
                __is_public_layout_mode__ = isPbulic
                refresh()
            }
        )

    /**
     * 화면 갱신
     * 내부에서도 반드시 이 것을 쓸 것
     */
    const refresh = () => {
        __flg_refresh__ = !__flg_refresh__
        setRefresh(__flg_refresh__)
    }

    /**
     * 해당 url의 문서를 찾기
     * @param {string} uri 찾을 uri
     * @returns md 문자열
     */
    const getHelpDocPath = uri => __doc__list__[uri]

    const getSessionDate = () => _session_start_dt

    return (
        <GlobalContext.Provider
            value={{
                loginInfo: getLoginInfo,
                setSSOinfo,
                getSessionDate,
                gotoLoginPage,
                login,
                logout,
                refresh,
                getLayoutMode,
                setLayoutMode,
                setPublicLayout,
                setuserInfo,
                gotoPage,
                getHelpDocPath,
                setSessionStartDt
            }}
        >
            {children}
        </GlobalContext.Provider>
    )
}

export default GlobalProvider
